import { ReactNode, useState } from 'react';
import { GlobalContext } from './GlobalContext';
import { AuthorProps, HymnProps } from '../types';

type Props = {
  children?: ReactNode
}

export const GlobalProvider = ({ children }: Props) => {
  const [currentTimer, setCurrentTimer] = useState<number>(0);
  const [totalTimer, setTotalTimer] = useState<number>(0);
  const [hymnId, setHymnId] = useState<number>(1);
  const [hymn, setHymn] = useState<HymnProps>();
  const [hymns, setHymns] = useState<HymnProps[]>([]);
  const [favorites, setFavorites] = useState<HymnProps[]>([]);
  const [authors, setAuthors] = useState<Record<number, AuthorProps>>([]);
  const [textSearch, setTextSearch] = useState<string>('');
  const [startDownload, setStartDownload] = useState<boolean>(false);

  return (
    <GlobalContext.Provider value={{
      currentTimer,
      setCurrentTimer,
      totalTimer,
      setTotalTimer,
      hymnId,
      setHymnId,
      hymn,
      setHymn,
      hymns,
      setHymns,
      authors,
      setAuthors,
      textSearch,
      setTextSearch,
      favorites,
      setFavorites,
      startDownload,
      setStartDownload
    }}>
      { children }
    </GlobalContext.Provider>
  )
}
